module.exports = __webpack_public_path__ + "static/media/clint_mckoy_VZfRITK8sKs_unspla.ff1147a8.png";